
import { fetchAllBanks } from "../../api/fetchers";
import React, { useEffect, useMemo, useState } from "react";
import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Loader from "../loader";

const norm = (c) => String(c || "").toUpperCase();

const ChooseBankModal = ({ isOpen, onClose, onSelectBank }) => {
    const [search, setSearch] = useState("");
    const [banks, setBanks] = useState([]);
    const [isLoadingBanks, setIsLoadingBanks] = useState(false);
    const location = useLocation();

    const business = useSelector((state) => state.business);
    const businessId = business?._id;

    const isCryptoToFiatFlow = location.pathname.includes("fiat-wallet");
    const isCrossBorder = location.pathname.includes("cross-border");

    const cryptoFiat = useSelector((s) => s.cryptoFiatTransfer);
    const { currency } = useSelector((s) => s);
    const cb = useSelector((s) => s.crossBorderTransfer);
    const bankProvider = useSelector((s) => s.bankProvider);
    const provider = useSelector((s) => s.provider);
    const source = isCrossBorder ? cb?.provider?.name || "" : (bankProvider || provider)?.name || "";

    const { currencyFrom, currencyTo } = useMemo(() => {
        if (isCrossBorder && cb) {
            return {
                currencyFrom: norm(cb.fromCurrency || currency),
                currencyTo: norm(cb?.recipient?.toCurrency || currency),
            };
        }

        if (isCryptoToFiatFlow) {
            const toFiat = cryptoFiat?.recipient?.toCurrency || cryptoFiat?.toCurrency || null;
            return {
                currencyFrom: norm(cryptoFiat?.currency || currency),
                currencyTo: norm(toFiat || currency),
            };
        }

        return { currencyFrom: norm(currency), currencyTo: norm(currency) };
    }, [isCrossBorder, cb, isCryptoToFiatFlow, cryptoFiat, currency]);

    useEffect(() => {
        const loadBanks = async () => {
            try {
                if (!businessId || !isOpen) return;
                setIsLoadingBanks(true);
                const response = await fetchAllBanks({
                    currencyFrom,
                    currencyTo,
                    businessId,
                    source,
                });

                setBanks(Array.isArray(response) ? response : []);
            } catch (error) {
                console.error("Error fetching banks:", error);
            } finally {
                setIsLoadingBanks(false);
            }
        };

        loadBanks();
        return () => {
            setBanks([])
            setIsLoadingBanks(false)
        };
    }, [businessId, isOpen, currencyFrom, currencyTo, source]);

    const filteredBanks = banks.filter((bank) =>
        (bank?.name || "").toLowerCase().includes(search.toLowerCase())
    );

    const groupedBanks = filteredBanks.reduce((acc, bank) => {
        const firstLetter = (bank?.name?.[0] || "#").toUpperCase();
        (acc[firstLetter] ||= []).push(bank);
        return acc;
    }, {});

    return (
        <Modal
            show={isOpen}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="border-0 "
            onHide={onClose}
        >
            <Modal.Body
                className="bg-[#F7F9FC] w-full rounded-xl p-6 relative">
                <button onClick={onClose} className="absolute top-4 right-4 text-2xl">
                    <IoClose />
                </button>

                <h2 className="text-xl font-semibold mb-4">
                    Choose bank
                    {/* {currencyFrom && currencyTo ? ` (${currencyFrom} → ${currencyTo})` : ""} */}
                </h2>

                <input
                    type="text"
                    placeholder="Search banks"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-full p-2 !shadow-none mb-4 rounded-md bg-[#F2F3FC]"
                />

                <div className="space-y-4 max-h-64 overflow-y-auto">
                    {isLoadingBanks ? (
                        <div className="flex items-center justify-center h-20"><Loader color="#6F00FF" /></div>
                    ) : Object.keys(groupedBanks)
                        .sort()
                        .map((letter) => (
                            <div key={letter}>
                                <p className="text-sm text-[#98A2B3] font-semibold mb-2">
                                    {letter}
                                </p>
                                <div className="space-y-2 bg-white rounded-xl p-2 mr-4">
                                    {groupedBanks[letter].map((bank, idx) => (
                                        <div
                                            key={`${bank?.code || bank?.id || idx}`}
                                            onClick={() => {
                                                onSelectBank(bank);
                                                onClose();
                                            }}
                                            className="flex items-center gap-3 p-2 cursor-pointer hover:bg-[#F9FAFB] rounded-md"
                                        >
                                            <span className="text-[#101828] font-medium">
                                                {bank?.name || "Unknown Bank"}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChooseBankModal;
